<bm-ext-header></bm-ext-header>

<div class="content">
  <router-outlet></router-outlet>
</div>

<div class="logout">
  <button (click)="logout()" class="button-pale">Выйти из аккаунта</button>
</div>
